/**
 * Created by calhosh on 4/14/2017.
 */

export const HTTP_REQUEST_METHODS = {
	// The GET method requests a representation of the specified resource. Requests using GET should only retrieve data.
	GET: 'GET',
	// The HEAD method asks for a response identical to that of a GET request, but without the response body.
	HEAD: 'HEAD',
	// The POST method is used to submit an entity to the specified resource, often causing a change in state or side effects on the server.
	POST: 'POST',
	// The PUT method replaces all current representations of the target resource with the request payload.
	PUT: 'PUT',
	// The DELETE method deletes the specified resource.
	DELETE: 'DELETE',
	// The CONNECT method establishes a tunnel to the server identified by the target resource.
	CONNECT: 'CONNECT',
	// The OPTIONS method is used to describe the communication options for the target resource.
	OPTIONS: 'OPTIONS',
	// The TRACE method performs a message loop-back test along the path to the target resource.
	TRACE: 'TRACE',
	// The PATCH method is used to apply only partial modifications to a resource.
	PATCH: 'PATCH'
};

export const ERRORS = {
	NO_RESOURCE_SPECIFIED: 'No resource was specified.'
};

export const serviceURL = 'serviceUrl';

export const successMessageDisplayDuration = 3000;

export const budgetPagingOptions = {
	options: [10, 20]
};

export const defaultPagingOptions = {
	options: [10, 20]
};

export const indDetailsPagingOptions = {
	options: [20, 50]
};

export const numberFormats = [
	{
		value: '1,234,567,890',
		label: 'numbericStlye1',
		title: '1,234,567,890',
		numberFormatMap: 0
	},
	{
		value: '1.234.567.890',
		label: 'numbericStlye3',
		title: '1.234.567.890',
		numberFormatMap: 3
	},
	{
		value: '1,23,45,67,890',
		label: 'numbericStlye7',
		title: '1,23,45,67,890',
		numberFormatMap: 1
	},
	{
		value: '1 234 567 890',
		label: 'numbericStlye2',
		title: '1 234 567 890',
		numberFormatMap: 2
	}
];

export const showMoreMinLines = [
	{value: 1, label: 'showMoreMinLineOne'},
	{value: 2, label: 'showMoreMinLineTwo'},
	{value: 3, label: 'showMoreMinLineThree'},
	{value: 4, label: 'showMoreMinLineFour'},
	{value: 5, label: 'showMoreMinLineFive'},
	{value: 6, label: 'showMoreMinLineSix'}
];

export const defaultValues = {
	languageIsoCode: 'en-us',
	dateFormat: 'yyyy/MM/dd',
	numberFormat: '1,234,567,890',
	negativeNumberFormat: '(1.1)',
	roundingFormat: 'none',
	currencyFormat: 'global'
};

export const minorErrorCodes = [1001];

export const budgetObjectCalculationType = [
	{value: 'currency', label: 'currency'},
	{value: 'hour', label: 'hour'},
	{value: 'rate', label: 'rate'}
];

export const budgetTableColumns = [
	{value: 'total', label: 'total'},
	{value: 'budget', label: 'budget'},
	{value: 'actual', label: 'actual'},
	{value: 'remaining', label: 'remaining'},
	{value: 'adjustment', label: 'adjustment'},
	{value: 'estimate', label: 'estimate'},
	{value: 'forecast', label: 'forecast'},
	{value: 'variance', label: 'variance'},
	{value: 'priorBudget', label: 'priorBudget'},
	{value: 'priorActual', label: 'priorActual'}
];

export const SystemsCodes = {
	CANVAS: 1,
	MERCURY: 2,
	GFIS: 3
};

export const SystemsList = [
	{value: SystemsCodes.MERCURY, label: 'Mercury'},
	{value: SystemsCodes.GFIS, label: 'GFIS'}
];

export const Features = ['projects', 'projectSummary'];

export const Entities = [
	'clients',
	'workspaces',
	'clientWorkspaces',
	'engagements'
];

export const AdministratorRole = [
	{value: 3, label: 'Application admin reader'},
	{value: 4, label: 'Application admin writer'},
	{value: 5, label: 'Application super admin'}
];

export const EngagementPrefix = [
	{
		value: 'E',
		label: 'E'
	}
];

export const UserLookupType = {
	NotSpecified: 0,
	Internal: 1,
	External: 2
};

export const Theme = {
	Light: 'light',
	Dark: 'dark'
};

export const Currency = {
	Global: 'Global',
	Local: 'Local'
};

export const CurrencyCode = {
	Global: '20',
	Local: '10'
};

export const ServiceLines = [
	{value: 0, label: 'All service lines'},
	{value: 1, label: 'Assurance'},
	{value: 2, label: 'Advisory'},
	{value: 3, label: 'TAS'},
	{value: 4, label: 'Tax'},
	{value: 5, label: 'GCO'},
	{value: 6, label: 'Other'}
];

export const budgetFinancialTabs = {
	summary: 'summary',
	financialAnalysis: 'financialAnalysis',
	billingExpenses: 'billingExpenses',
	independence: 'Independence'
};

export const projectAggregationTypes = {
	project: 'Project',
	financialEngagementId: 'FinancialEngagement',
	subServiceLine: 'SubserviceLine',
	user: 'User',
	none: 'None'
};

export const financialLineChartTabs = {
	allAvailable: 'allAvailable',
	allAdded: 'allAdded'
};

export const systemAdministratorRoles = {
	none: 0,
	applicationAdminReader: 3,
	applicationAdminWriter: 4,
	applicationSuperAdmin: 5
};

export const independenceStatus = {
	IncompleteNotInvited: 1,
	IncompleteInProgress: 2,
	CompletedOther: 3,
	CompletedValidatedInCanvas: 4
};

//Customized table default selection
export const defaultCustomizedOptions = [
	{id: 1, checked: true, label: 'Team Member'},
	{id: 2, checked: true, label: 'EY Canvas independence status'},
	{id: 3, checked: false, label: 'Member firm'},
	{id: 4, checked: false, label: 'Country'},
	{id: 5, checked: true, label: 'Hours charged'},
	{id: 6, checked: true, label: 'Overall independence status'},
	{id: 7, checked: true, label: 'Confirmation date'},
	{id: 8, checked: false, label: 'Employment Status'},
	{id: 9, checked: false, label: 'Updated by'},
	{id: 10, checked: false, label: 'Updated date'}
];

export const projectStatus = {
	active: 1,
	deleted: 2
};

export const projectUserRoles = {
	defaultUser: 1,
	projectAdministrator: 2
};

export const projectUserStatus = {
	active: 1,
	inactive: 2
};

export const loadingAreas = {
	admin: 'admin',
	addAdmin: 'addAdmin',
	app: 'app',
	addUser: 'addUser',
	independence: 'independence',
	independenceDetails: 'independenceDetails',
	independenceStatusChangeModal: 'independenceStatusChangeModal',
	independenceStatusInviteUsersModal: 'independenceStatusInviteUsersModal'
};

export const sections = {
	toolbar: 'toolbar',
	search: 'search',
	details: 'details',
	tabs: 'tabs',
	footer: 'footer'
};

export const routesResources = {
	admin: 'admin',
	projects: 'projects',
	users: 'users',
	administrators: 'administrators'
};

export const modalSource = {
	adminContainer: 'adminContainer',
	search: 'search',
	logo: 'logo',
	navUser: 'navUser'
};

export const toastAreas = {
	project: 'project',
	reactiveModal: 'reactiveModal'
};

export const userType = {
	member: 'member',
	guest: 'guest',
	admin: 'admin'
};

export const displayByEnum = {
	serviceLine: 'serviceLine',
	subServiceLine: 'subServiceLine',
	rank: 'rank',
	teamMember: 'teamMember',
	expenseType: 'expenseType'
};

export const independenceStatusFilterEnum = {
	country: 'Country',
	memberFirm: 'memberFirm',
	independenceStatus: 'independenceStatus',
	confirmationDateBefore: 'confirmationDateBefore',
	confirmationDateAfter: 'confirmationDateAfter'
};

export const independenceStatuses = [
	{value: 1, label: 'Incomplete - Not invited'},
	{value: 2, label: 'Incomplete - In progress'},
	{value: 3, label: 'Completed - Other'},
	{value: 4, label: 'Completed - Validated In EY Canvas'}
];

export const storageKeys = {
	financialAnalysisDisplayByKey: 'financialAnalysisDisplayBy_',
	billingExpensesDisplayByKey: 'billingExpensesDisplayBy_',
	financialProgressIsExpandedKey: 'financialProgressIsExpanded_',
	financialLineChartCheckedKey: 'financialLineChartChecked_',
	financialLineChartAllCheckedKey: 'financialLineChartAllChecked_',
	projectRailFilterKey: 'projectRailFilter_',
	financialCodesKey: '_financialCodes_',
	canvasEngagementsKey: '_canvasEngagements_',
	clientsKey: '_clients_',
	independenceCustomizedColumnKey: 'independenceCustomizedColumns_',
	independenceEngagementDisplayByKey: 'independenceEngagementDisplayBy_',
	filteredFinancialCodekey: '_filteredFinancialCodes_',
	clientOrEngagementSearchKey: 'clientOrEngagementSearchKey',
	showUnassociatedEngagementKey: 'showUnassociatedEngagementKey',
	independenceRailFilterKey: 'independependenceRailFilter_',
	independenceSearchByTeamMemberKey: 'independenceSearchByTeamMemberKey',
};

export const operation = {
	Add: 'Add',
	Remove: 'Remove'
};

export const independenceKeyType = {
	EngagementTeamMember: 1
};

export const independenceSource = {
	mercury: 0,
	zeus: 1,
	economics: 2
};

export const independenceDataSource = {
	none: 0,
	zeus: 1,
	economics: 2,
	mercury: 3
};

export const canvasIndependenceStatus = [
	{ value: 1, label: 'Incomplete' },
	{ value: 2, label: 'No Matters Identified' },
	{ value: 3, label: 'Matter Identified - Pending Action' },
	{ value: 4, label: 'Matter Resolved - Denied Access' },
	{ value: 5, label: 'Matter Resolved - Granted Access' },
	{ value: 6, label: 'Not Applicable' },
	{ value: 7, label: 'Restored' },
	{ value: 8, label: 'Override' },
	{ value: 9, label: 'Prior - No Matters Identified' },
	{ value: 10, label: 'Prior - Matter Identified - Pending Action' },
	{ value: 11, label: 'Prior - Matter Resolved - Granted Access' },
	{ value: 12, label: 'Prior - Matter Resolved - Denied Access' }
];

export const statusTerminated = 5;
export const statusNoLongerWithFirm = 3;
